import { MerchantCategory } from '@nemuru-eng/js-api-client';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { SelectOption } from '@/types/selectOption';

export const MerchantCategoryOptions = (t: GetTextIdTranslationType): SelectOption[] =>
  Object.values(MerchantCategory).map((value) => ({
    value,
    display: t(value) || value,
  }));
